import { render } from "./EmployeeInfo.vue?vue&type=template&id=20bd1151"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js"

import "./EmployeeInfo.vue?vue&type=style&index=0&id=20bd1151&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__